module.exports = __webpack_public_path__ + "img/Jump Casting75.1ef47aa3.jpg";